import { memo } from 'react';

function FutureMarker({ backgroundColor, borderColor, size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M22.78 18V6L12.39 0L2 6V18L12.39 24L22.78 18Z" fill={backgroundColor} />
      <path
        d="M12.39 1.15L21.78 6.57V17.42L12.39 22.84L3 17.42V6.58L12.39 1.15ZM12.39 0L2 6V18L12.39 24L22.78 18V6L12.39 0Z"
        fill={borderColor}
      />
      <path d="M16.7 15.9999H14.08V10.3099H8.39001V7.68994H16.7V15.9999Z" fill={borderColor} />
      <path
        d="M14.4669 8.07542L7.46411 15.0733L9.31608 16.9266L16.3189 9.92869L14.4669 8.07542Z"
        fill={borderColor}
      />
    </svg>
  );
}

export default memo(FutureMarker);
